<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card flat>
          <v-card-text>
    <p align="center">
      <strong><u>ПОЛИТИКА ЗА „БИСКВИТКИ”</u></strong>
    </p>
    <p align="center">
      Политика за „Бисквитки” на АРТИКЕТ EООД, ЕИК: 205660717
    </p>
    <p>
      Ние от АРТИКЕТ EООД се ангажираме да предоставяме най-добрите услуги на
      клиентите си, като с това се стремим да поддържаме доверието, което ни
      гласуват. За нас е важно клиентите ни да бъдат запознати как уебсайтът ни
      използва „Бисквитки” и с каква цел те се съхраняват на компютъра им.
    </p>
    <p>
      „Бисквитките“ са малки текстови файлове, които се генерират и съхраняват на
      компютъра, смартфона или друго устройство, през което посещавате уебсайта
      ни. „Бисквитките“ са широко използвана технология, която Ви предоставя
      следните предимства:
    </p>
    <p>
      1. възможност за по-лесно и бързо сърфиране;
    </p>
    <p>
      2. възможност за защитена връзка с уебсайт;
    </p>
    <p>
      3. възможност за по-добро потребителското изживяване чрез предоставяне на
      съдържание, адаптирано спрямо Вашите лични интереси.
    </p>
    <p>
      Информацията, която се съхранява от „бисквитките“ на Вашия компютър за
      ограничен период от време, може да се отнася до: конкретните уеб страници,
      които сте посещавали; реклами, на които сте кликали; видът на самия
      браузър, който ползвате, както и информация, която вече сте предоставили на
      уебсайта (разрешили сте ползването на "бисквитки" и не се налага повторното
      въвеждане на същите данни). Предоставената информация понякога е свързана и
      с Вашия IP адрес.
    </p>
    <p>
      Нашият уебсайт може да съдържа „бисквитки“ на трети страни (компании за
      измерване на аудитория; доставчици на персонализирана реклама и т.н). Тези
      „бисквитки“ на трети страни позволяват съхранението на статистическа
      информация и предоставяне на персонализирана реклама при сърфиране в
      уебсайта.
    </p>
    <p>
      Реклами за нашия уебсайт могат да се появят на рекламни пространства на
      трети страни. Тези реклами се управляват от партньори на АРТИКЕТ EООД,
      следователно и „бисквитките“, съхраняващи се на дадения сайт, се управляват
      от третите страни. Нашата компания не носи отговорност за управлението на
      тези „бисквитки”, предоставени от трети страни, затова Ви съветваме да се
      запознаете с Политиките за поверителност и защита на лични данни и
      управление на „бисквитки” на съответните страни.
    </p>
    <p>
      На нашия уебсайт може да се съдържат елементи от трети страни (бутони към
      социалните медии), които Ви позволяват да споделяте съдържание от нашия
      уебсайт или да добавяте коментари. В това число се включват бутони за
      социалните медии като „Сподели“, „Харесай“, „g+1” и “Tweet”. При вход в
      социалните медии, като Фейсбук и Туитър, тези бутони могат да Ви
      идентифицират, без да е необходимо да ги ползвате при достъпване на нашия
      уебсайт. В допълнение, когато сте се свързали с конкретна социална медия,
      при взаимодействие с бутон (напр. кликвайки на бутона „Харесай“ или
      оставяйки коментари) съответната информация ще бъде публикувана на Вашия
      профил. Моля, запознайте се с Политиките за поверителност и защита на лични
      данни на тези социални медии и информацията съхранявана от тях за каква цел
      бива използвана, включително и рекламната им цел. При нежелание от Ваша
      страна социалните медии да Ви идентифицират или да съхраняват информация за
      Вас чрез нашия уебсайт е необходимо да излезете от профила си в социалната
      медияи да се запознаете с Политиките за поверителност и защита на лични
      данни на тези социални медии и информацията съхранявана от тях. С
      използването на предоставения Инструмент за управление на „бисквитки“ на
      нашия уебсайт, може да упражните правото на избор за съхраняване/отхвърляне
      на „бисквитките“ от социалните медии, които са в пряко взаимодействие с
      уебсайта ни.
    </p>
    <p>
      Употребата на „бисквитки“ на трети страни е обект на Политиката за
      поверителност и защита на личните данни на третите страни.
    </p>
    <p>
      Нашият Инструмент за управление на „бисквитки“ съхранява Вашите
      предпочитания, които сте определили в „Настройки за „бисквитки“
    </p>
    <p>
      Предотвратяването „бисквитките“ да бъдат съхранени на Вашето устройство не
      ограничава възможността за появяване на реклами в рекламното пространство,
      което виждате. Вашият отказ от съхранението им предотвратява таргетирането
      Ви за персонализирана реклама.
    </p>
    <p>
      Ако компютърът Ви се използва от повече от един човек или разполага с
      повече от един браузър е възможно изборът Ви за определени „бисквитки“ да
      не е постоянен. Ние не сме в състояние да предвидим тези външни фактори и
      поради тази причина нямаме възможност да гарантираме последователността на
      Вашите избори.
    </p>
    <p>
      Ако използвате различни устройства, за да достъпвате нашия уебсайт
      (смартфон, таблет и/или десктоп компютър), предпочитанията Ви трябва да
      бъдат настроени на всеки един от тях.
    </p>
    <p>
      Повече информация за „бисквитки“ не само за тези, ползвани на уебсайта на
      АРТИКЕТ EООД, както и за възможностите за контролирането им, може да
      намерите на http://www.youronlinechoices.com/bg/, публикувана от Интерактив
      Адвъртайзинг Бюро България (IAB България).
    </p>
    <p>
      В съответствие с Директива 2002/58/EC, Вие имате право да изискате отчет за
      личните си данни. Повече информация относно защита на Вашите лични данни,
      може да намерите на www.articket.eu
    </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
	export default {
		name: '',
		components: {},
		mixins: [],
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		mounted() {
		},
		methods: {}
	}
</script>

<style></style>
